import { cx } from './utils/cx'

export type FileKind = 'image' | 'video' | 'audio' | 'mp3' | 'doc' | 'zip' | 'raw'

const LABELS: Record<FileKind, string> = {
  image: 'TIF',
  video: 'MOV',
  audio: 'WAV',
  mp3: 'MP3',
  doc: 'DOC',
  zip: 'ZIP',
  raw: 'RAW'
}

export function FileThumb({ kind = 'doc', size, label }: { kind?: FileKind; size?: 'lg'; label?: string }) {
  return <div className={cx('st-thumb', kind, size)}>{label || LABELS[kind] || 'FILE'}</div>
}
